import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { isAuthenticated, isAuthorized } from "@kdose/ng-auth";
import { NextaCanDeactivateCrudForm } from "../shared/nexta-crud/nexta-can-deactivate.guard";
import { ClientFormComponent } from "./client-form.component";
import { ClientListComponent } from "./client-list.component";

const clientRoutes: Routes = [
	{
		path: "clients",
		component: ClientListComponent,
		canActivate: [isAuthenticated, isAuthorized],
		data: {
			requiredAuthorizations: {
				oneOf: ["ADMIN"],
			},
		},
	},
	{
		path: "clients/neu",
		component: ClientFormComponent,
		canDeactivate: [NextaCanDeactivateCrudForm],
		canActivate: [isAuthenticated, isAuthorized],
		data: {
			requiredAuthorizations: {
				oneOf: ["ADMIN"],
			},
		},
	},
	{
		path: "clients/:id",
		component: ClientFormComponent,
		canDeactivate: [NextaCanDeactivateCrudForm],
		canActivate: [isAuthenticated, isAuthorized],
		data: {
			requiredAuthorizations: {
				oneOf: ["ADMIN"],
			},
		},
	},
];
@NgModule({
	imports: [RouterModule.forChild(clientRoutes)],
	exports: [RouterModule],
})
export class ClientRoutingModule {}
